/* src/app/cardholders/visitor-cards/visitor-card-account-details/visitor-card-account-details.component.css */
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=visitor-card-account-details.component.css.map */
